// extracted by mini-css-extract-plugin
module.exports = {"count":"HitsHeader_count__6gQXf","hidden":"HitsHeader_hidden__NJEw_"};